import React, { useState, useEffect } from "react"
import { Collapse, Row } from "reactstrap"
import classnames from "classnames"
import ViewImage from "../Screen/ViewImage"
import moment from "moment"
import { maintainSelectedIndex } from "store/actions"
import { useDispatch } from "react-redux"

const AccordianDataMultiple = props => {
  const {
    item,
    sethandleAccordion1,
    handleAccordion1,
    keyId,
    setphotoIndex,
    setisGallery,
    keyIndex,
    activeReportStatus,
  } = props
  const dispatch = useDispatch()

  const handleOnclickAccordionMulti = (value, key) => {
    // multiple date open date show image click gallery
    dispatch(maintainSelectedIndex(key))
    if (handleAccordion1 === value) {
      sethandleAccordion1(null)
    } else {
      sethandleAccordion1(value)
    }
  }

  const [multipleScreenDateProject, setmultipleScreenDateProject] = useState([])

  useEffect(() => {
    const groupedData = (item?.screenLogs || []).reduce((acc, data) => {
      // Format the capturetime to YYYY-MM-DD
      const formattedDate = moment(data.capturetime).format("YYYY-MM-DD")
      // Add the data to the corresponding group based on the formatted date
      if (!acc[formattedDate]) {
        acc[formattedDate] = []
      }
      acc[formattedDate].push(data)
      return acc
    }, {})

    setmultipleScreenDateProject(groupedData)
  }, [item, activeReportStatus])
  
  return (
    <React.Fragment>
      <Row>
        <div className="accordion" id="accordion" key={keyIndex}>
          <div className="accordion-item mb-2">
            <h2 className="accordion-header" id="headingOne">
              <button
                className={classnames(
                  "accordion-button zIndexes zIndexesNo",
                  "fw-medium",
                  {
                    collapsed: handleAccordion1 !== keyIndex,
                  }
                )}
                type="button"
                onClick={() => handleOnclickAccordionMulti(keyIndex, keyId)}
                style={{ cursor: "pointer" }}
              >
                {keyId}
              </button>
            </h2>
            <Collapse
              isOpen={handleAccordion1 === keyIndex}
              className="accordion-collapse"
            >
              <div className="accordion-body">
                <div className="text-muted">
                  <div
                    className="selectAllBody modal-body"
                    style={{ maxHeight: "70vh", overflowY: "auto" }}
                  >
                    
                    {activeReportStatus?.id !== 2 ? (
                      <ViewImage
                        item={item}
                        setphotoIndex={setphotoIndex}
                        setisGallery={setisGallery}
                        dateKey={false}
                      />
                    ) : (
                      <>
                  
                        {Object.entries(multipleScreenDateProject).map(
                          ([key, value], index) => (
                            <div key={index}>
                              <div className="text-center">
                                Date: <strong>{key}</strong>
                              </div>

                              <ViewImage
                                item={value}
                                setphotoIndex={setphotoIndex}
                                setisGallery={setisGallery}
                                dateKey={true}
                                sethandleAccordion1={sethandleAccordion1}
                                handleAccordion1={handleAccordion1}
                              />
                            </div>
                          )
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </Collapse>
          </div>
        </div>
      </Row>
    </React.Fragment>
  )
}

export default AccordianDataMultiple
